export default class SelectFacility {

    public init(): void {
       
        const selectFacilityModal = $("#select-facility-modal");
        if(selectFacilityModal.length > 0) {
            selectFacilityModal.modal({backdrop: "static", keyboard: false});
            selectFacilityModal.modal("show");

            $(".select-facility-label").on("click", (e) => {
                $(".select-facility-label .bordered-option").removeClass("selected");
                $(e.currentTarget).children(".bordered-option").addClass("selected");
                const btn = $(".select-facility-btn");
                btn.removeClass("disabled")
                btn.attr("href", $(e.currentTarget).data("href"));
            });
        }
    }
}
